import uuid from 'uuid';
export default () => uuid.v4();
